const api = {
    GET_USER_BILL_ABSTRACT: "/users/billabstract",
    GET_CUSTOMERS: "/customers",
    GET_INVENTORIES: "/inventory",
    LOGIN: "/users/signin",
    GET_WORKFLOW: "/workflow",
};

export default api;
